import React from 'react';

import { ICourse } from '../../../../../store/admin/courses/store';

import Tooltip from '../../../../../components/Tooltip';
import TeeBoxRows from './TeeAssignationRows/TeeBoxRows';
import { TeeBoxAssignmentsStyled } from './TeeBoxAssignments.Styles';
import { TitleContainerStyled } from './TitleContainerStyled';

interface IProps {
  setTeeAssignationsNotSaved: any;
  course?: ICourse;
}

const TeeBoxAssignments = (props: IProps) => {
  const { course, setTeeAssignationsNotSaved } = props;

  return (
    <TeeBoxAssignmentsStyled elevation={1} className={'paper paper-full'}>
      <TitleContainerStyled>
        <h3 className="title-tooltip override">TEE BOX ASSIGNMENTS</h3>

        <Tooltip
          classes={{ fab: 'tooltip-fab--shift-top-2dot5' }}
          sectionKey="ROUND_BASICS.TEEBOX_ASSIGNMENTS"
        />
      </TitleContainerStyled>

      <TeeBoxRows onNotSavedChange={setTeeAssignationsNotSaved} course={course} />
    </TeeBoxAssignmentsStyled>
  );
};

export default TeeBoxAssignments;
